import "./Scrollbars.scss"

import { forwardRef, PropsWithChildren } from "react"
import { Scrollbars as CustomScrollbars, ScrollbarProps } from "react-custom-scrollbars-2"
import cn from "classnames"
interface IScrollbarsProps extends ScrollbarProps {
    thick?: boolean
}

const Scrollbars = forwardRef<CustomScrollbars, PropsWithChildren<IScrollbarsProps>>(({ thick, ...props }, ref) => {
    return <CustomScrollbars
        autoHeight
        autoHeightMin="100%"
        autoHeightMax="100%"
        hideTracksWhenNotNeeded
        renderTrackHorizontal={() => <div className={cn("scrollbars__track scrollbars__track--horizontal", thick && "scrollbars__track--horizontal-thick")} />}
        renderThumbHorizontal={p => <div {...p} className={cn("scrollbars__thumb scrollbars__thumb--horizontal", thick && "scrollbars__thumb--horizontal-thick")} />}
        renderTrackVertical={() => <div className={cn("scrollbars__track scrollbars__track--vertical", thick && "scrollbars__track--vertical-thick")} />}
        renderThumbVertical={p => <div {...p} className={cn("scrollbars__thumb scrollbars__thumb--vertical", thick && "scrollbars__thumb--vertical-thick")} />}
        {...props}
        ref={ref}
    />
})

Scrollbars.displayName = "Scrollbars"

export default Scrollbars
